exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_wks-ext.js
// module id = ZxII
// module chunks = 0